import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage, getCurrentLocale } from '../../../contexts/LanguageContext';
import { usePermissions } from '../../../hooks/usePermissions';



const FullServiceInvoiceTable = ({ invoices, loading, totalCount, lazyParams, onPage, onSort, onEdit, onDelete, handleEdit, hidePrice = false, isCanUseFullService = false }) => {
    const { th, getCurrentLocale } = useLanguage();
    const { hasAdminRole } = usePermissions();

    // Yetki kontrolü: Sadece Kmobility kullanıcıları silebilir
    const canDelete = hasAdminRole() || isCanUseFullService;

    const actionTemplate = (rowData) => (
        <div className="flex gap-2 justify-content-center">
            <i onClick={() => handleEdit(rowData)} className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem', color: '#0B3187' }} title={th('fullServiceInvoice.tooltips.edit')} />
            {canDelete && <i onClick={() => onDelete(rowData.id)} className="pi pi-trash cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem', color: '#0B3187' }} title={th('fullServiceInvoice.tooltips.delete')} />}
        </div>
    );

    const DEALER_TYPE_LABEL = (dealerType) => {
    if (Number(dealerType) === 1) return th('fullServiceInvoice.dealerTypeLabels.domestic');
    if (Number(dealerType) === 2) return th('fullServiceInvoice.dealerTypeLabels.foreign');
    return '';
};

    const dateBody = (rowData, col) => {
        const v = rowData[col.field];
        if (!v) return '';
        const d = new Date(v);
        return d.toLocaleDateString(getCurrentLocale || 'tr-TR');
    };

    const dealerTypeBody = (rowData) => DEALER_TYPE_LABEL(rowData?.dealerType ?? rowData?.DealerType);

    const mainDealerBody = (rowData) => {
        const dealerType = rowData?.dealerType ?? rowData?.DealerType;
        if (Number(dealerType) !== 2) return '';
        return rowData?.mainDealerName ?? rowData?.MainDealerName ?? '';
    };

    return (
        <DataTable
            value={invoices}
            paginator
            rows={lazyParams.rows}
            totalRecords={totalCount}
            lazy
            first={lazyParams.first}
            className="p-datatable-gridlines"
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            loading={loading}
            emptyMessage={th('fullServiceInvoice.emptyMessage')}
            rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            sortMode="single"
            removableSort
        >
            <Column body={actionTemplate} header={th('fullServiceInvoice.columns.actions')} style={{ width: '10%' }} alignHeader="center" align="center" />
            <Column header={th('fullServiceInvoice.columns.dealerType')} body={dealerTypeBody} sortable sortField="dealerType" />
            <Column field="chassisNo" header={th('fullServiceInvoice.columns.chassisNo')} sortable />
            <Column field="dealerName" header={th('fullServiceInvoice.columns.dealerName')} sortable />
            {!hidePrice && <Column field="agreementAmount" header={th('fullServiceInvoice.columns.agreementAmount')} sortable />}
            {!hidePrice && <Column field="agreementAmountWithKDV" header={th('fullServiceInvoice.columns.agreementAmountWithKDV')} sortable />}
            <Column field="currency" header={th('fullServiceInvoice.columns.currency')} sortable />
            <Column field="contractStartDate" header={th('table.contractStartDate')} body={dateBody} sortable />
            <Column field="contractEndDate" header={th('table.contractEndDate')} body={dateBody} sortable />
            <Column field="description" header={th('fullServiceInvoice.columns.description')} sortable />
        </DataTable>
    );
};

export default FullServiceInvoiceTable;
